import { useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import ConsultaFornecedor from '../../../../../lib/json/consultas/FornecedorSelect.json'
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import { useNavigate } from "react-router-dom";
import { usePopUp } from "../../../../components/BootBox";
import ConsultaTotvs from "../../../../../backend/ConsultaTotvs";
import { handleFornecedorCodigo, handleFornecedorTipo, handleFornecedorMunicipio, handleAvaliacao } from "../../../../components/GridCell/Fornecedor";
import SelectFixo from "../../../../components/SelectFixo";
import SelectTipoFornecimento from "../../../../components/Select/TipoFornecimento";
import { useSessionStorageState } from "../../../../../hooks/useSessionStorageState";
import InputGeral from "../../../../components/InputGeral/Index";
import { encryptAES } from "../../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";

function ListaFornecedor(){
    const navigate = useNavigate();
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const columns = [
        {
            Header: 'Filial',
            accessor: 'A2_FILIAL',
        },
        {
            Header: 'Fornecedor',
            accessor: 'A2_COD',
            Cell: handleFornecedorCodigo
        },
        {
            Header: 'Tipo Fornecimento',
            accessor: 'A2_XTPFOR',
            Cell: handleFornecedorTipo
        },
        {
            Header: 'Municipio / UF',
            accessor: 'A2_MUN',
            Cell: handleFornecedorMunicipio
        },
        {
            Header: 'Avaliação',
            accessor: 'A2_MEDIA',
            Cell: handleAvaliacao
        },
    ];
    
    const nMediaHomologado = window._env_?.REACT_APP_MEDIA_HOMOLOGACAO

    const optionsStatus = [
        {
            value: '99',
            text: "Todos",
            filtroSQL: "( 1 = 1 )"
        },
        {
            value: '0',
            text: "Qualificado",
            filtroSQL: "A2_XTPFORN != 'N' AND A2_MEDIA >= " + nMediaHomologado
        },
        {
            value: '1',
            text: "Não Qualificado",
            filtroSQL: "A2_XTPFORN != 'N' AND A2_MEDIA < " + nMediaHomologado
        },
        {
            value: '2',
            text: "Não Aplicável",
            filtroSQL: "A2_XTPFORN = 'N'"
        },
    ]

    const [carregar, setCarregar] = useState(false);
    const [data, setData] = useState([]);
    const [fornecedor, setFornecedor] = useSessionStorageState("fornececorFiltro", "");
    const [tipoFornecimento, setTipoFornecimento] = useSessionStorageState("fornececorTipo", null);
    const [avaliacao, setAvaliacao] = useSessionStorageState("fornececorAvaliacao", optionsStatus[1]);
    
    const retornaConsultaDefault = () => {
        var consultaDefault = ConsultaFornecedor.consulta;
        
        consultaDefault += "WHERE SA2.D_E_L_E_T_ <> '*' AND A2_FILIAL = FILIAL(SA2) ";
        
        if(fornecedor) {
            consultaDefault += "AND ( A2_COD LIKE '%" + fornecedor + "%' OR A2_NOME LIKE '%" + fornecedor+ "%' ) ";
        }
        if(tipoFornecimento?.value) {
            consultaDefault += "AND A2_XTPFOR = '" + tipoFornecimento?.value + "' ";
        }
        if(avaliacao?.value) {
            consultaDefault += "AND " + avaliacao.filtroSQL + " ";
        }
        
        consultaDefault += "ORDER BY A2_FILIAL, A2_COD, A2_LOJA, A2_NOME ";

        return consultaDefault
    }

    // Processa consulta do grid
    const loadFornecedor = async () => {
        const consulta = retornaConsultaDefault()
        setCarregar(true);
        var retConsulta = await ConsultaTotvs( consulta, ConsultaFornecedor.tabelas );

        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.original.A2_COD}/${row.original.A2_LOJA}/${row.original.EMPRESA}${row.original.M0_CODFIL.trim()}`)
    }

    const handleContatos = (row) => {
        navigate(`./Contatos/${row.original.A2_COD}/${row.original.A2_LOJA}/${row.original.EMPRESA}${row.original.M0_CODFIL.trim()}`)
    }

    const handleHomologacao = (row) => {
        const lHomologado = row.original.A2_XTPFORN === 'N' || ( row.original.A2_XTPFORN !== 'N' && row.original.A2_MEDIA >= nMediaHomologado )
        const secretKey = window._env_?.REACT_APP_KEY_COTACAO
        const empresaFilial = localStorage.getItem('empresaFilial');

        const dadosCotacao = JSON.stringify({
            Filial: empresaFilial,
            Numero: "HOMSA2",
            Fornecedor: row.original.A2_COD,
            Loja: row.original.A2_LOJA,
            Contato: row.original.A2_CONTATO,
            EmailAcesso: row.original.A2_EMAIL,
            Homologado: lHomologado
        });

        const encryptedText = encryptAES(dadosCotacao, secretKey);
        const urlhomologacao = window._env_?.REACT_APP_URL + '/compras/Homologacao/Fornecedor/' + encryptedText

        const Mensagem = (
            <Row>
                <Col md={10}>
                    <InputGeral
                        tipo={'text'}
                        value={urlhomologacao}
                        disabled={true}
                    />
                </Col>
                <Col md={2}>
                    <Button
                        variant="primary"
                        onClick={() => {
                        navigator.clipboard.writeText(urlhomologacao);
                        toast.success("Copiado com Sucesso");
                        }}
                        style={{ marginLeft: "8px" }}
                    >Copiar URL</Button>
                </Col>
            </Row>
        );
	
		const buttonsRender = [
			{ variant: 'primary', action: FechaBootBox, label: 'Fechar' }
		];
	
		DisparaBootBox('Homologação Fornecedor - Link de Acesso', Mensagem, buttonsRender, 0, FechaBootBox, 'xl', false);
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage 
                    text="Fornecedor"
                    exibirIncluir={false}
                />
            </Col>
            <Col md="6" xs="12">
                <InputGeral 
                    label="Fornecedor"
                    tipo='text'
                    value={fornecedor}  // Define o valor do campo com base no estado
                    onChange={(e) => setFornecedor(e.target.value)}
                />
            </Col>
            <Col md="3" xs="12">
                <SelectTipoFornecimento
                    campoTipoFornecimento={tipoFornecimento}
                    changeTipoFornecimento={setTipoFornecimento}
                />
            </Col>
            <Col md="3" xs="12">
                <SelectFixo 
                    options={optionsStatus} 
                    value={avaliacao} 
                    selectedOptionValue={avaliacao}
                    isLabel={true} 
                    label="Avaliação" 
                    onChange={(e) => setAvaliacao(e)}
                />
            </Col>
            <Col md="3" xs="12">
                <Form.Group as={Col} className="md-2" controlId="formGridBuscar">
                    <InputGroup size="md" className="mb-3">
                        <Button variant="outline-primary" type="submit" onClick={loadFornecedor}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons= {[
                            {isVisual: true, action: handleHomologacao, label: "Link Homologação", icone: "MdFilePresent"},
                            {isVisual: true, action: handleContatos, label: "Contatos", icone: "MdContactMail", style: "success"}
                            // {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"}
                        ]}
                        isIgnorar={true}
                        paginacao={200}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaFornecedor;